import { useState } from "react";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";
import { errMsg, mediaUrl } from "@/lib/api";
import { uploadFile } from "@/lib/upload";
import { Input } from "@/components/ui/input";

const Preview = ({ value, isImage }) => {
  if (!value) return null;
  if (isImage) return <img src={mediaUrl(value)} alt="" className="h-24 object-cover border" />;
  return <p className="text-xs text-zinc-500 truncate">Fichier : {value}</p>;
};

export const FileUpload = ({ value, onChange, accept, label, testId }) => {
  const [loading, setLoading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setLoading(true);
    try {
      const data = await uploadFile(file);
      onChange(data.url);
      toast.success("Fichier téléversé");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <label className={`flex-1 flex items-center gap-2 border-2 border-dashed px-3 h-10 cursor-pointer text-sm transition-colors ${loading ? "opacity-60" : "hover:border-red-600"}`}>
          <Upload size={15} className="text-red-600" />
          <span className="text-zinc-600 truncate">{loading ? "Téléversement…" : label || "Choisir un fichier…"}</span>
          <input data-testid={`${testId}-file`} type="file" accept={accept} className="hidden" disabled={loading} onChange={(e) => upload(e.target.files[0])} />
        </label>
        {value && <button type="button" onClick={() => onChange("")} aria-label="Retirer" className="w-10 h-10 border flex items-center justify-center hover:bg-red-50 hover:text-red-600"><X size={14} /></button>}
      </div>
      <Input data-testid={`${testId}-url`} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="…ou coller une URL" className="rounded-none text-xs" />
      <Preview value={value} isImage={accept?.startsWith("image")} />
    </div>
  );
};
